<template>
  <Head :title="'Widget: ' + widget.name" />
  <div>
    <h1 class="mb-6 text-2xl font-bold">Detail Widget</h1>

    <div class="mb-6">
      <Link
        :href="route('widgets.index')"
        class="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
      >
        Kembali
      </Link>
      <Link
        :href="route('widgets.edit', widget.id)"
        class="px-4 py-2 ml-2 text-white bg-blue-500 rounded hover:bg-blue-600"
      >
        Edit
      </Link>
    </div>

    <div class="p-6 bg-white rounded-lg shadow-md">
      <div class="mb-4">
        <h2 class="text-lg font-semibold">Nama Widget</h2>
        <p>{{ widget.name }}</p>
      </div>

      <div class="mb-4">
        <h2 class="text-lg font-semibold">Komponen</h2>
        <p>{{ widget.component }}</p>
      </div>

      <div class="mb-4">
        <h2 class="text-lg font-semibold">Deskripsi</h2>
        <p>{{ widget.description || "Tidak ada deskripsi" }}</p>
      </div>

      <div class="mb-4">
        <h2 class="text-lg font-semibold">Urutan</h2>
        <p>{{ widget.order }}</p>
      </div>

      <div class="mb-4">
        <h2 class="text-lg font-semibold">Status</h2>
        <span
          :class="{
            'bg-green-100 text-green-700': widget.is_active,
            'bg-red-100 text-red-700': !widget.is_active,
          }"
          class="px-3 py-1 text-xs font-medium rounded-full"
        >
          {{ widget.is_active ? "Aktif" : "Nonaktif" }}
        </span>
      </div>

      <div class="mb-4">
        <h2 class="text-lg font-semibold">Konfigurasi</h2>
        <pre class="p-3 overflow-x-auto bg-gray-100 rounded">{{
          JSON.stringify(widget.config || {}, null, 2)
        }}</pre>
      </div>

      <div class="mb-4">
        <h2 class="text-lg font-semibold">Dibuat pada</h2>
        <p>{{ new Date(widget.created_at).toLocaleString() }}</p>
      </div>

      <div>
        <h2 class="text-lg font-semibold">Terakhir diperbarui</h2>
        <p>{{ new Date(widget.updated_at).toLocaleString() }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { Head, Link } from "@inertiajs/vue3";
const route = inject('route');

const props = defineProps({
  widget: Object,
});
</script>
